/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_Level_DisqualificationInputs */



/**
* | output |
* | --- |
* | "Disqualification" |
*
* @param {Sanction_Level_DisqualificationInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_level_disqualification = /** @type {((inputs?: Sanction_Level_DisqualificationInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Level_DisqualificationInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Disqualification")
	if (locale === "es") return /** @type {LocalizedString} */ ("Descalificación")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Desqualificação")
	if (locale === "it") return /** @type {LocalizedString} */ ("Squalifica")
	return /** @type {LocalizedString} */ ("Disqualification")
});